module.exports = __webpack_public_path__ + "static/media/shopify.79c907ed.png";